export default __webpack_public_path__ + "static/uniswap@2x-87e78c4a0d2a2b48a28db3d3ffe76b97.png";